"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHandleEndPolicyChange = void 0;
var next_newfront_api_1 = require("@newfront-insurance/next-newfront-api");
var next_notifications_1 = require("@newfront-insurance/next-notifications");
var use_mutation_1 = __importDefault(require("use-mutation"));
// TODO: should be removed once use-mutation lib types are fixed
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/explicit-module-boundary-types
function useHandleEndPolicyChange() {
    var endPolicyChange = next_newfront_api_1.usePolicyChange();
    var notifications = next_notifications_1.useNotifications();
    return use_mutation_1.default(function (_a) {
        var policyLegacyId = _a.policyLegacyId, data = _a.data;
        return endPolicyChange(policyLegacyId, data);
    }, {
        onFailure: function () {
            notifications.add({
                type: 'error',
                title: "There was a problem ending the policy.\n          Please try again and contact bugs@newfront.com if you\u2019re unable to end the policy.",
            });
        },
        throwOnFailure: true,
    });
}
exports.useHandleEndPolicyChange = useHandleEndPolicyChange;
